import { render, staticRenderFns } from "./givenset.vue?vue&type=template&id=7aaa9709&scoped=true"
import script from "./givenset.vue?vue&type=script&lang=js"
export * from "./givenset.vue?vue&type=script&lang=js"
import style0 from "./givenset.vue?vue&type=style&index=0&id=7aaa9709&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa9709",
  null
  
)

export default component.exports